import { useEffect, useState } from 'react';

export function useOutsideAlerter(ref) {
  const [outside, setOutside] = useState(false);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOutside(true);
      } else {
        setOutside(false);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      setOutside(false);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return outside;
}
